module.exports = __webpack_public_path__ + "img/static.00b582c2.jpg";